// Brand logotype used across every auth screen.
//
// Uses the real Six Figure Agent OS logo image (public/brand/
// sixfigureagentcrm-logo.jpg) so the login/signup pages match the
// marketing site at sixfigureagentcrm.com.
//
// Brand name, tagline, and logo path are all overridable via env vars
// so you can rebrand without code changes:
//   REACT_APP_BRAND_NAME      defaults to "Six Figure Agent OS"
//   REACT_APP_BRAND_TAGLINE   defaults to the SFA tagline
//   REACT_APP_BRAND_LOGO_URL  defaults to the bundled JPG
//
// The image already includes the wordmark, so the typographic side
// is hidden by default. Pass `withWordmark` if you ever swap in a
// mark-only logo.

import React from 'react';

export const BRAND_NAME    = process.env.REACT_APP_BRAND_NAME    || 'Six Figure Agent OS';
export const BRAND_TAGLINE = process.env.REACT_APP_BRAND_TAGLINE || 'The AI Operating System for Insurance Agencies';
export const BRAND_LOGO_URL = process.env.REACT_APP_BRAND_LOGO_URL || '/brand/sixfigureagentcrm-logo.jpg';

export default function BrandLogo({ size = 'md', withWordmark = false }) {
  const sizes = {
    sm: { h: 'h-12'  },
    md: { h: 'h-20'  },
    lg: { h: 'h-28'  },
    xl: { h: 'h-36'  },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div className="inline-flex flex-col items-center">
      <img
        src={BRAND_LOGO_URL}
        alt={BRAND_NAME}
        className={`${s.h} w-auto object-contain`}
        // The image is on a black background. Auth panels are also
        // dark so it blends cleanly. We don't add an outer ring or
        // rounding so the logo carries its own composition.
      />
      {withWordmark && (
        <div className="mt-2 font-bold tracking-tight text-white text-lg">
          {BRAND_NAME}
        </div>
      )}
    </div>
  );
}
